// Salesforce cloud silhouette — recognizable mark used wherever a row links
// to its Salesforce lead. Brand-blue (#00A1E0).

interface Props {
  size?: number
}

export default function SalesforceMark({ size = 16 }: Props) {
  return (
    <svg
      viewBox="0 0 273 191"
      width={size}
      height={Math.round((size * 191) / 273)}
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Salesforce"
      style={{ display: 'inline-block', verticalAlign: 'middle', flexShrink: 0 }}
    >
      <path
        fill="#00A1E0"
        d="M113.7 41c8.8-9.2 21.1-14.9 34.7-14.9 18.1 0 33.9 10.1 42.3 25.1 7.3-3.3 15.4-5.1 24-5.1 32.9 0 59.5 26.9 59.5 60.1s-26.6 60.1-59.5 60.1c-4 0-7.9-.4-11.7-1.2-7.4 13.2-21.5 22.1-37.7 22.1-6.8 0-13.2-1.6-18.9-4.4-7.5 17.6-25 30-45.4 30-21.2 0-39.3-13.4-46.3-32.2-3 .6-6.2 1-9.4 1C19.8 181.6.1 161.9.1 137.6c0-16.3 8.9-30.5 22.2-38.1-2.7-6.2-4.2-13.1-4.2-20.3C18.1 51.4 40.6 28.9 68.6 28.9c16.4 0 31 7.9 40.2 20.1 1.6-2.7 3.3-5.4 4.9-8z"
      />
    </svg>
  )
}
